import styled from 'styled-components';

export const Label = styled.label`
  font-family: 'Helvetica Neue', Helvetica;
  font-size: 14px;
  font-weight: 700;
  color: #394760;
  text-wrap: nowrap;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const SwitchContainer = styled.div`
  margin-top: 6px;
  display: flex;
  align-items: center;
  gap: 16px;
  user-select: none;
`;

export const SwitchLabel = styled.span<{ isActive: boolean; isLeft: boolean }>`
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;
  transition: color 0.2s ease;
  color: ${({ isActive, isLeft }) => {
    if (isLeft) {
      // Label "Não"
      return isActive ? '#A8A8A8' : '#525252';
    }
    // Label "Sim"
    return isActive ? '#0055FF' : '#A8A8A8';
  }};
`;

export const SwitchTrack = styled.div<{ disabled?: boolean }>`
  position: relative;
  width: 48px;
  height: 16px;
  background-color: #d9d9d9;
  border-radius: 8px;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  transition: background-color 0.2s ease;
  opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};
`;

export const SwitchThumb = styled.div<{ isActive: boolean; disabled?: boolean }>`
  position: absolute;
  top: -4px;
  left: ${({ isActive }) => (isActive ? '24px' : '0px')};
  width: 24px;
  height: 24px;
  background-color: ${({ isActive }) => (isActive ? '#0055FF' : '#525252')};
  border: 0.5px solid #ffffff;
  border-radius: 50%;
  transition: all 0.2s ease;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};
`;
